import { render, staticRenderFns } from "./stuInfo.vue?vue&type=template&id=16d2e8d4"
import script from "./stuInfo.vue?vue&type=script&lang=js"
export * from "./stuInfo.vue?vue&type=script&lang=js"
import style0 from "./stuInfo.vue?vue&type=style&index=0&id=16d2e8d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports